export default __webpack_public_path__ + "8ed7f4a6d8376e69bc739816a4c01342.svg";